import React, { useState } from "react";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import { Button, Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";
// import Table from "../../../../../core/pagination/datatable";

// import { Button } from "react-bootstrap";

// import {
//   ChevronUp,
//   RotateCcw,
//   Filter,
// } from "feather-icons-react/build/IconComponents";

const ViewPayments = () => {
  //   const renderTooltip = (props) => (
  //     <Tooltip id="pdf-tooltip" {...props}>
  //       Pdf
  //     </Tooltip>
  //   );
  //   const renderExcelTooltip = (props) => (
  //     <Tooltip id="excel-tooltip" {...props}>
  //       Excel
  //     </Tooltip>
  //   );
  //   const renderRefreshTooltip = (props) => (
  //     <Tooltip id="refresh-tooltip" {...props}>
  //       Refresh
  //     </Tooltip>
  //   );
  //   const renderFilterTooltip = (props) => (
  //     <Tooltip id="refresh-tooltip" {...props}>
  //       Filter
  //     </Tooltip>
  //   );
  //   const renderCollapseTooltip = (props) => (
  //     <Tooltip id="refresh-tooltip" {...props}>
  //       Collapse
  //     </Tooltip>
  //   );
  const [payDrawerOpen, setPayDrawerOpen] = useState(false);

  return (
    <>
      

      <div className="page-wrapper">
        <div className="content pt-2">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb d-flex justify-content-between w-100">
              <div className="d-flex align-items-center">
                <li className="breadcrumb-item">
                  <Link to="/crm/estimates">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item mb-0" aria-current="page">
                  Payment Info
                </h4>
              </div>
              <ul
                className="nav nav-tabs nav-tabs-bottom"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <Link
                    className="nav-link active"
                    id="estimate-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#estimate-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="estimate-tab-pane"
                    aria-selected="true"
                  >
                    payments
                  </Link>
                </li>
                <li className="nav-item d-none" role="presentation">
                  <Link
                    to="#"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      setPayDrawerOpen(true);
                    }}
                  >
                    Pay
                  </Link>
                </li>
              </ul>

              {/* Back to List Button */}
              <div className="page-btn d-flex justify-content-between align-items-center flex-wrap gap-2">
                <span className="badge  px-3 py-2 g-2">{"Draft"}</span>

                {/* Right - Buttons */}
                <div className="d-flex align-items-center gap-2">
                  {/* <Link className="btn btn-secondary btn-sm">
            <i className="fas fa-edit"></i>
          </Link> */}
                  <Link className="btn btn-info  btn-sm">
                    <i className="fas fa-envelope"></i>
                  </Link>
                  <Link className="btn btn-primary  btn-sm">
                    More <i className="fas fa-chevron-down"></i>
                  </Link>
                  <Link className="btn btn-primary  btn-sm">
                    <i className="fas fa-check"></i> INV-2025/1786
                  </Link>
                  <Link to="/crm/estimates" className="btn btn-dark btn-sm">
                    <i className="ti ti-arrow-left"></i>
                  </Link>
                </div>
              </div>
            </ol>
          </nav>

          <div className="container-fluid">
            {/* Card with Tabs */}

            <div className="card shadow proposal-summary">
              <div className="card-body pb-1 ">
                <div className="row align-items-center">
                  <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                    <div className="d-inline-flex align-items-center">
                      <span className="fw-bold me-2">Payment No:</span>
                      <span className="fw-bold text-danger">PAY-1234</span>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                    <div className="d-inline-flex align-items-center">
                      <i className="fa-regular fa-calendar me-2"></i>
                      <span className="fw-bold me-2">Invoice :</span>
                      <span className="fw-bold">
                        {/* {dayjs(estimateDetails?.Estimate.datecreated).format(
                  "DD-MM-YYYY"
                )} */}{" "}
                        24-08-2026
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                    <div className="d-inline-flex align-items-center">
                      <i className="fa-regular fa-clock  me-2"></i>
                      <span className="fw-bold me-2">Payment :</span>
                      <span className="fw-bold">
                        {/* {dayjs(estimateDetails?.Estimate.expirydate).format(
                  "DD-MM-YYYY"
                )} */}
                        24-09-2026
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6 mb-2 text-center">
                    <div className="d-inline-flex align-items-center">
                      <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                      <span className="fw-bold me-2">Total:</span>
                      <span className="fw-bold text-success">
                        ₹{" "}
                        {/* {Number(estimateDetails?.Estimate.total).toLocaleString()} */}
                        1,00,000
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card shadow ">
              <div className="card-body pt-1">
                <div className="tab-content" id="myTabContent">
                  {/* Estimate Tab Content */}
                  <div
                    className="tab-pane fade show active"
                    id="estimate-tab-pane"
                    role="tabpanel"
                    aria-labelledby="estimate-tab"
                  >
                    <div className="row mt-3">
                      <div className="col-5">
                        <h6 className=" fw-bold mb-3">
                          <i className="fa-solid fa-building me-2"></i>
                          Perennial Code IT Consultants Pvt. Ltd.
                        </h6>

                        <p className="mb-1">
                          <i className="fa-solid fa-map-location-dot  me-2"></i>
                          Vidya Nagar, Hyderabad, Telangana, INDIA - 500044
                        </p>

                        <p className="mb-1">
                          <i className="fa-solid fa-file-invoice  me-2"></i>
                          GSTIN: 36AAHCP3604R1ZM
                        </p>

                        <p className="mb-0">
                          <i className="fa-solid fa-phone-volume  me-2"></i>
                          +91 4048513363, +91 8297230010
                        </p>
                      </div>
                      <div className="col-3 d-flex justify-content-start align-items-end">
                        <div className="text-start">
                          <p className="mb-0">
                            <i className="fa-solid fa-user-check me-2"></i>
                            <strong>CreatedBy:</strong>{" "}
                            {/* {estimateDetails?.AddedByName || "-"} */}
                            shiva yadav
                          </p>
                        </div>
                      </div>
                      <div className="col-4 d-flex justify-content-end">
                        <div className="text-end">
                          <h6>To:</h6>
                          <p className="mb-1">
                            {" "}
                            <i className="fa-solid fa-user-tie  me-2"></i>
                            {/* {estimateDetails?.Estimate.ClientName || "-"} */}
                            FIT4IFE INDIA
                          </p>
                          <p className="mb-1">
                            {" "}
                            <i className="fa-solid fa-city  me-2"></i>
                            {/* {estimateDetails?.Estimate.billing_street},{" "}
                    {estimateDetails?.Estimate.billing_city},{" "}
                    {estimateDetails?.Estimate.billing_state} -{" "}
                    {estimateDetails?.Estimate.billing_zip} */}
                            Madhapur , Hyderabad, Telangana , INDIA
                            <br />
                            GSTIN: 36ADTPC0759Q22T
                            <br />
                            <i className="ti ti-phone me-1" />
                            98674757358, 83683676386
                          </p>
                        </div>
                      </div>
                    </div>

                    <hr />

                    {/* Table Section */}
                    <div className="table-responsive">
                      <table className="table align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>Invoice</th>
                            <th>Date</th>
                            <th className="text-end">Invoice Amount</th>
                            <th className="text-end">Paid Amount</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>
                              <Link
                                to="#"
                                className="fw-semibold text-primary text-decoration-none"
                              >
                                INV-2025/1378
                              </Link>
                            </td>

                            <td>21 Mar 2025</td>

                            <td className="text-end fw-semibold">₹21,240.00</td>

                            <td className="text-end">
                              <span className="fw-bold text-success">
                                ₹21,240.00
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="row mt-2">
                      {/* <div className="col-8 text-start">
                <p>
                  <strong>Note:</strong>
                </p>
                <p>Payment Terms: 100% Advance.</p>

                <p>
                  <strong>Axis Bank Details:</strong>
                </p>
                <p>Account Name: Perennial Code IT Consultants Pvt Ltd</p>
                <p>Bank: Axis Bank, Nallakunta, Hyderabad</p>
                <p>Account# 914020041433504</p>
                <p>IFC Code UTIB0001381</p>

                <p>
                  <strong>Terms & Conditions</strong>
                </p>
                <p>
                {estimateDetails?.Estimate.terms}
                </p>
              </div> */}
                      <div className="col-8">
                        <div className="row g-3">
                          {/* Bank Details */}
                          <div className="col-md-6">
                            <div
                              className="card h-100 border-0"
                              style={{
                                background: "#eef7ff",
                                borderRadius: "12px",
                              }}
                            >
                              <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                  <div
                                    className="d-flex align-items-center justify-content-center me-2"
                                    style={{
                                      width: "38px",
                                      height: "38px",
                                      borderRadius: "8px",
                                      background: "#d9edff",
                                    }}
                                  >
                                    <i
                                      className="ti ti-building-bank"
                                      style={{
                                        fontSize: "20px",
                                        color: "#1677ff",
                                      }}
                                    ></i>
                                  </div>

                                  <h6 className="mb-0 fw-semibold">
                                    Axis Bank Details
                                  </h6>
                                </div>

                                <div className="mb-2">
                                  <small className="text-muted d-block">
                                    Account Name
                                  </small>
                                  <span className="fw-medium">
                                    Perennial Code IT Consultants Pvt Ltd
                                  </span>
                                </div>

                                <div className="mb-2">
                                  <small className="text-muted d-block">
                                    Bank
                                  </small>
                                  <span className="fw-medium">
                                    Axis Bank, Nallakunta, Hyderabad
                                  </span>
                                </div>

                                <div className="row">
                                  <div className="col-md-7">
                                    <small className="text-muted d-block">
                                      Account Number
                                    </small>
                                    <span className="fw-medium">
                                      914020041433504
                                    </span>
                                  </div>

                                  <div className="col-md-5">
                                    <small className="text-muted d-block">
                                      IFSC Code
                                    </small>
                                    <span className="fw-medium">
                                      UTIB0001381
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Terms & Conditions */}
                          <div className="col-md-6">
                            <div
                              className="card h-100 border-0"
                              style={{
                                background: "#f8faff",
                                borderRadius: "12px",
                              }}
                            >
                              <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                  <div
                                    className="d-flex align-items-center justify-content-center me-2"
                                    style={{
                                      width: "38px",
                                      height: "38px",
                                      borderRadius: "8px",
                                      background: "#e9f1ff",
                                    }}
                                  >
                                    <i
                                      className="ti ti-file-description"
                                      style={{
                                        fontSize: "20px",
                                        color: "#1677ff",
                                      }}
                                    ></i>
                                  </div>

                                  <h6 className="mb-0 fw-semibold">
                                    Terms & Conditions
                                  </h6>
                                </div>

                                <p className="text-muted mb-0">
                                  {"No terms available."}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-4 text-end">
                        <table
                          className="table text-end"
                          style={{ height: 200 }}
                        >
                          <tbody>
                            <tr>
                              <td>Sub Total</td>
                              <td>
                                ₹{" "}
                                {Number(
                                  // estimateDetails?.Estimate.subtotal
                                  90000
                                ).toLocaleString()}
                              </td>
                            </tr>

                            <tr>
                              <td>Total Tax</td>
                              <td>
                                ₹{" "}
                                {Number(
                                  // estimateDetails?.Estimate.total_tax
                                  9000
                                ).toLocaleString()}
                              </td>
                            </tr>

                            <tr>
                              <td>Adjustment</td>
                              <td>
                                ₹{" "}
                                {Number(
                                  // estimateDetails?.Estimate.adjustment
                                  80000
                                ).toLocaleString()}
                              </td>
                            </tr>

                            <tr className="table-primary bg-light">
                              <td>Total</td>
                              <td>
                                ₹{" "}
                                {Number(
                                  // estimateDetails?.Estimate.total
                                  100000
                                ).toLocaleString()}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Drawer
            title="Payment"
            open={payDrawerOpen}
            // onClose={handleCloseReminderDrawer}
            width={550}
            destroyOnClose
            maskClosable={true}
            closable={false}
            extra={
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={() => setPayDrawerOpen(false)}
              />
            }
          >
            <form>
              <div className="row">
                {/* Amount */}
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">
                    Amount Received
                  </label>

                  <div className="input-group">
                    <span className="input-group-text bg-light">₹</span>

                    <input
                      type="text"
                      className="form-control bg-light"
                      value="21,240.00"
                      readOnly
                    />
                  </div>
                </div>

                {/* Payment Date */}
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">Payment Date</label>

                  <input
                    type="date"
                    className="form-control"
                    value="2025-03-27"
                    readOnly
                  />
                </div>

                {/* Payment Mode */}
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">Payment Mode</label>

                  <select className="form-select" defaultValue="Bank">
                    <option value="Bank">Bank</option>
                    <option value="Cash">Cash</option>
                    <option value="UPI">UPI</option>
                    <option value="Cheque">Cheque</option>
                    <option value="Card">Card</option>
                  </select>
                </div>

                {/* Payment Method */}
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">
                    Payment Method
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter payment method"
                  />
                </div>

                {/* Transaction ID */}
                <div className="col-md-12 mb-3">
                  <label className="form-label fw-semibold">
                    Transaction ID
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    value="Axis Bank"
                    readOnly
                  />
                </div>

                {/* Note */}
                <div className="col-12 mb-4">
                  <label className="form-label fw-semibold">Note</label>

                  <textarea
                    className="form-control"
                    rows={3}
                    placeholder="Add a note..."
                  />
                </div>

                {/* Save Button */}
                <div className="d-flex justify-content-end">
                  <button type="submit" className="btn btn-primary  py-2">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </Drawer>

          <CommonFooter />
        </div>
      </div>
    </>
  );
};
export default ViewPayments;
